import { Route, Routes, Navigate } from "react-router-dom";

import useAuth from "hooks/use-auth";

import Login from "pages/Login";
import Users from "pages/users";
import UserProfile from "pages/users/profile";
import Colleagues from "pages/colleague";
import AddColleagues from "pages/colleague/add";
import ColleagueProfile from "pages/colleague/profile";
import Discount from "pages/discount";
import AddDiscount from "pages/discount/add";
import Question from "pages/common-question";
import AddQuestion from "pages/common-question/add";
import EditQuestion from "pages/common-question/edit";
import News from "pages/news";
import AddNews from "pages/news/add";
import EditNews from "pages/news/edit";
import NewsCategory from "pages/news/category";
import EditNewsCategory from "pages/news/category/Edit";
import AddNewsCategory from "pages/news/category/add";
import AboutUs from "pages/aboutus";
import ContactUs from "pages/contactus";
import ContactUs2 from "pages/contactus/accessory";
import Rules from "pages/rules";
import Privacy from "pages/privacy";
import CartMessage from "pages/cartmessage";
import Messages from "pages/message";
import MessageDetails from "pages/message/messageDetails";
import Complaints from "pages/complaint";
import ComplaintDetails from "pages/complaint/messageDetails";
import Category from "pages/category";
import EditCategory from "pages/category/Edit";
import AddCategory from "pages/category/add";
import EditDesign from "pages/design/Edit";
import AddDesign from "pages/design/add";
import Products from "pages/products";
import AddProduct from "pages/products/add";
import EditProduct from "pages/products/edit";
import AddColors from "pages/products/color";
import EditColors from "pages/products/color/edit";
import AddImages from "pages/products/images";
import License from "pages/license";
import Gallery from "pages/gallery";
import Notification from "pages/notification";
import AddThemeNotification from "pages/notification/add";
import OrdersStats from "pages/ordersStats";
import Orders from "pages/orders/AllOrders";
import OrderDetail from "pages/orders/factor";
import EditAddress from "pages/address/edit";
import Comment from "pages/comment";
import CommentDetails from "pages/comment/messageDetails";
import MainSlide from "pages/slider/main";
import AccSlide from "pages/slider/accessory";
import Ticket from "pages/ticket";
import TicketDetails from "pages/ticket/messageDetails";
import Question_Answer from "pages/q&a";
import Question_AnswerDetails from "pages/q&a/messageDetails";
import Views from "pages/views";
import Branch from "pages/branch";
import PaymentRules from "pages/paymentrules";

export default function RoutesCM() {
  const AuthCTX = useAuth();

  if (!AuthCTX.isLoggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Orders />} />
      <Route path="/users" element={<Users />} />
      <Route path="/users/:userId" element={<UserProfile />} />
      <Route path="/colleague" element={<Colleagues />} />
      <Route path="/colleague/add" element={<AddColleagues />} />
      <Route path="/colleague/:colleagueId" element={<ColleagueProfile />} />
      <Route path="/orders/Stats" element={<OrdersStats />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/orders/:orderId" element={<OrderDetail />} />
      <Route path="/address/:addressId" element={<EditAddress />} />
      <Route path="/discount" element={<Discount />} />
      <Route path="/discount/add" element={<AddDiscount />} />
      <Route path="/question" element={<Question />} />
      <Route path="/addquestion" element={<AddQuestion />} />
      <Route path="/question/edit/:questionId" element={<EditQuestion />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/add" element={<AddNews />} />
      <Route path="/news/:articleId" element={<EditNews />} />
      <Route path="/news/category" element={<NewsCategory />} />
      <Route path="/news/category/add" element={<AddNewsCategory />} />
      <Route path="/news/category/:categoryId" element={<EditNewsCategory />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/contactaccessory" element={<ContactUs2 />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cartmessage" element={<CartMessage />} />
      <Route path="/message" element={<Messages />} />
      <Route path="/messages/:messageId" element={<MessageDetails />} />
      <Route path="/complaint" element={<Complaints />} />
      <Route path="/complaint/:complaintId" element={<ComplaintDetails />} />
      <Route path="/category" element={<Category />} />
      <Route path="/category/add" element={<AddCategory />} />
      <Route path="/category/:categoryId" element={<EditCategory />} />
      <Route path="/design/add/:categoryId" element={<AddDesign />} />
      <Route path="/design/:designId" element={<EditDesign />} />
      <Route path="/products" element={<Products />} />
      <Route path="/products/:productId" element={<EditProduct />} />
      <Route path="/products/add" element={<AddProduct />} />
      <Route path="/color/:productId" element={<AddColors />} />
      <Route path="/color/edit/:colorId" element={<EditColors />} />
      <Route path="/product/image/:colorId" element={<AddImages />} />
      <Route path="/license" element={<License />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/mainslider" element={<MainSlide />} />
      <Route path="/slider" element={<AccSlide />} />
      <Route path="/notification" element={<Notification />} />
      <Route path="/notification/add" element={<AddThemeNotification />} />
      <Route path="/comment" element={<Comment />} />
      <Route path="/comment/:messageId" element={<CommentDetails />} />
      <Route path="/ticket" element={<Ticket />} />
      <Route path="/ticket/:messageId" element={<TicketDetails />} />
      <Route path="/question-answer" element={<Question_Answer />} />
      <Route
        path="/question-answer/:messageId"
        element={<Question_AnswerDetails />}
      />
      <Route path="/views" element={<Views />} />
      <Route path="/branch" element={<Branch />} />
      <Route path="/payment/rules" element={<PaymentRules />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
